var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdSaveChkboxOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 0.5H6.4C2.86538 0.5 0 3.36538 0 6.9V26.1C0 29.6346 2.86538 32.5 6.4 32.5H25.6C29.1346 32.5 32 29.6346 32 26.1V6.9C32 3.36538 29.1346 0.5 25.6 0.5ZM23.3472 12.4368C23.7541 11.9136 23.6599 11.1597 23.1367 10.7528C22.6136 10.3459 21.8597 10.4402 21.4528 10.9633L15.0416 19.2063C14.899 19.3896 14.6309 19.4134 14.4583 19.258L10.4028 15.6081C9.91016 15.1648 9.15141 15.2047 8.70806 15.6973C8.26471 16.1899 8.30464 16.9487 8.79725 17.392L12.8527 21.042C14.061 22.1293 15.9381 21.9628 16.936 20.6798L23.3472 12.4368Z",
    fill: "#F3F3F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdSaveChkboxOff);
export default __webpack_public_path__ + "static/media/idSaveChkbox-off.6c34d61222aa4ada258de1143dee2f6f.svg";
export { ForwardRef as ReactComponent };